import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ValidationError from '../../../common/ValidationError'

const Container = styled.div`
  padding: 5px 10px;
  background: white;
`
const ReasonsContainer = styled.div`
  border-radius: 5px;
  padding: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: white;
`
const CheckboxContainer = styled.div`
  display: flex;
`
const Checkbox = styled.input`
  margin: 4px 5px 0px 0px !important;
`
const NoteContainer = styled.div`
`
const Note = styled.textarea`
  width: 98%;
  resize: vertical;
`

const ProductSwitchReasons = ({ onReasonCheck, onNoteChange, productSwitchReasons, showNoteError }) => {
  const sortedProductSwitchReasons = productSwitchReasons.slice().sort((a, b) => a.description > b.description ? 1 : -1)
    .filter(reason => reason.key !== 'other')
  const other = productSwitchReasons.find(reason => reason.key === 'other')
  if (other) {
    sortedProductSwitchReasons.push(other)
  }
  return (
    <Container>
      <h4>Please select the reasons(s) for switching the loan product below.</h4>
      <ReasonsContainer>
        {sortedProductSwitchReasons.map(({ rid, description, key }) => {
          return (
            <CheckboxContainer key={key}>
              <Checkbox
                onChange={onReasonCheck}
                id={`${key}${rid}`}
                type="checkbox"
                name={description}
                value={key}
              />
              <label htmlFor={`${key}${rid}`}>
                {description}
              </label>
            </CheckboxContainer>
          )
        })}
      </ReasonsContainer>
      <NoteContainer>
        Additional Note
        <Note onChange={onNoteChange} rows="5" placeholder={'This is optional unless you selected "Others" as your reason'} />
      </NoteContainer>
      <ValidationError visible={showNoteError}>
        This section cannot be blank based on your selected reason above.
      </ValidationError>
    </Container>
  )
}

ProductSwitchReasons.propTypes = {
  onNoteChange: PropTypes.func.isRequired,
  onReasonCheck: PropTypes.func.isRequired,
  productSwitchReasons: PropTypes.arrayOf(PropTypes.object).isRequired,
  showNoteError: PropTypes.bool
}

export default ProductSwitchReasons
